module.exports = __webpack_public_path__ + "static/media/poneplay.f16edc2f.png";